import { addAuthzMetadataGrpcCall, buildGrpcClient } from "../../../../../lib/grpc";
import { SegmentRepository } from "../../domain/interfaces/SegmentRepository";
import { SegmentEntity } from "../../domain/segment.entity";
import { SegmentMapper } from "../mappers/SegmentMapper";
import { SegmentAPIPromiseClient } from "../../../../../gen/witbooking/backoffice/orchestrator/segment/v1/segment_api_grpc_web_pb";
import {
  CreateSegmentRequest,
  DeleteSegmentRequest,
  GetAllSegmentsRequest,
  GetSegmentRequest,
  UpdateSegmentRequest,
} from "../../../../../gen/witbooking/backoffice/orchestrator/segment/v1/segment_api_pb";

export class SegmentGrpcRepository implements SegmentRepository {
  private readonly client: SegmentAPIPromiseClient;

  constructor() {
    this.client = buildGrpcClient(SegmentAPIPromiseClient);
  }

  async findByProperty(propertyTicker: string): Promise<SegmentEntity[]> {
    const request = new GetAllSegmentsRequest();
    request.setPropertyTicker(propertyTicker);

    const call = addAuthzMetadataGrpcCall(this.client, this.client.getAllSegments);
    const response = await call(request, { "x-property": propertyTicker });

    return SegmentMapper.toDomainArray(response.getSegmentsList());
  }

  async findById(propertyTicker: string, id: string): Promise<SegmentEntity | null> {
    const request = new GetSegmentRequest();
    request.setPropertyTicker(propertyTicker);
    request.setId(id);

    const call = addAuthzMetadataGrpcCall(this.client, this.client.getSegment);
    const response = await call(request, { "x-property": propertyTicker });

    const segment = response.getSegment();
    return segment ? SegmentMapper.toDomain(segment) : null;
  }

  async create(propertyTicker: string, entity: SegmentEntity): Promise<SegmentEntity> {
    const request = new CreateSegmentRequest();
    request.setPropertyTicker(propertyTicker);
    request.setSegment(SegmentMapper.toProto(entity));

    const call = addAuthzMetadataGrpcCall(this.client, this.client.createSegment);
    const response = await call(request, { "x-property": propertyTicker });

    const segment = response.getSegment();
    if (!segment) {
      throw new Error("Unexpected response creating segment");
    }
    return SegmentMapper.toDomain(segment);
  }

  async update(propertyTicker: string, entity: SegmentEntity): Promise<void> {
    const request = new UpdateSegmentRequest();
    request.setPropertyTicker(propertyTicker);
    request.setSegment(SegmentMapper.toProto(entity));

    const call = addAuthzMetadataGrpcCall(this.client, this.client.updateSegment);
    await call(request, { "x-property": propertyTicker });
  }

  async delete(propertyTicker: string, id: string): Promise<void> {
    const request = new DeleteSegmentRequest();
    request.setPropertyTicker(propertyTicker);
    request.setId(id);

    const call = addAuthzMetadataGrpcCall(this.client, this.client.deleteSegment);
    await call(request, { "x-property": propertyTicker });
  }
}
